import { Box } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

import { MetricCard } from "~/components/UI/MetricCard";

export const MetricsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(1),
  flexWrap: "wrap",
  [theme.breakpoints.down("md")]: {
    gap: theme.spacing(0.75),
  },
}));

export const MetricSingleCard = styled(MetricCard)<{ $isInfo?: boolean }>(
  ({ theme, $isInfo }) => ({
    width: "max-content",
    backgroundColor: theme.palette.secondary.main,
    padding: "0.5rem 1rem",
    ...($isInfo && { paddingRight: "2.5rem" }),
    ...(theme.palette.mode === "dark" && {
      backgroundColor: alpha(theme.palette.common.white, 0.06),
    }),
    marginBottom: "12px",

    "& > div": {
      flexDirection: "row",
    },
  })
);
